import { logger } from 'helpers'
import CollapsableBox from './containers/CollapsableBox'
import StaticBox from './containers/StaticBox'
import ButtonToolbar from './containers/ButtonToolbar'
import Modal from './containers/Modal'
import BigModal from './containers/BigModal'
import ButtonGroup from './containers/ButtonGroup'
import LinkedToggle from './misc/LinkedToggle'
import ContentHeader from './containers/ContentHeader'
import StatBox from './displays/StatBox'
import StatWidget from './displays/StatWidget'
import ObjectFinder from './displays/ObjectFinder'
import Graph from './displays/Graph'
import LinkedInput from './inputs/LinkedInput'
import LinkedTextArea from './inputs/LinkedTextArea'
import LinkedPasswordInput from './inputs/LinkedPasswordInput'
import CountrySelect from './inputs/CountrySelect'
import FlowTable from './tables/FlowTable'
import OverviewTable from './tables/OverviewTable'
import Filter from './misc/Filter'
import NoContentBox from './displays/NoContentBox'
import ProgressBar from './displays/ProgressBar'
import EventInfoBox from './containers/EventInfoBox'
import FileUpload from './misc/FileUpload'
import LinkedInputGroup from './misc/LinkedInputGroup'
import Dropdown from './misc/Dropdown'
import InfoText from './displays/InfoText'
import Breadcrumbs from './displays/Breadcrumbs'
import AttributesBox from './containers/AttributesBox'
import StandaloneFilter from './misc/StandaloneFilter'
import LoadingIndicator from './displays/LoadingIndicator'
import ObjectPicker from './misc/ObjectPicker'
import Wizard from './containers/Wizard'
import InputButton from './misc/InputButton'
import Unauthorized from './displays/Unauthorized'
import FlowMap from './displays/FlowMap'
import LinkedObjectPickerInput from './inputs/LinkedObjectPickerInput'

var basic = {}
try {
  basic = require('../../projects/' + process.env.REACT_APP_PROJECT + '/components/basic/index.js')
} catch (e) {
  logger.debug('No project-specific core components')
}
module.exports = {
  Breadcrumbs,
  FileUpload,
  ObjectFinder,
  CollapsableBox,
  StaticBox,
  Modal,
  ButtonToolbar,
  ButtonGroup,
  ContentHeader,
  StatBox,
  StatWidget,
  Graph,
  LinkedInput,
  LinkedTextArea,
  LinkedPasswordInput,
  CountrySelect,
  FlowTable,
  OverviewTable,
  NoContentBox,
  BigModal,
  LinkedInputGroup,
  ProgressBar,
  Dropdown,
  EventInfoBox,
  AttributesBox,
  InfoText,
  LoadingIndicator,
  LinkedToggle,
  StandaloneFilter,
  ObjectPicker,
  Wizard,
  InputButton,
  Unauthorized,
  LinkedObjectPickerInput,
  Filter,
  FlowMap,
  ...basic
}



// WEBPACK FOOTER //
// ./src/components/basic/index.js